import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonItem, IonLabel } from "@ionic/react";
import { alertCircleOutline, refreshOutline } from "ionicons/icons";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    errorCode: string;
  }

const ErrorCode: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();

    if (props.errorCode == "Timeout" || props.errorCode == "Offline") {
        return (
          <IonCard>
            <IonCardHeader>
            <IonItem lines="none">
              <IonIcon slot="start" icon={alertCircleOutline}></IonIcon>
                <IonCardTitle>{t("Network error")}</IonCardTitle>
              </IonItem>
            </IonCardHeader>
            
            <IonCardContent>
              <IonItem lines="none">
                <IonLabel>{t("Either your device was not connected to the internet or our servers are experiencing technical difficulties.")}</IonLabel>
              </IonItem>
              <IonButton expand="block" onClick={() => window.location.reload()} style={{ marginTop: "1em" }}>
                <IonIcon slot="start" icon={refreshOutline} />
                {t("Refresh")}
              </IonButton>
            </IonCardContent>
          </IonCard>
        );
      } else {
        return (
        <IonCard>
            <IonCardHeader>
            <IonItem lines="none">
              <IonIcon slot="start" icon={alertCircleOutline}></IonIcon>
                <IonCardTitle>{t("Something went wrong...")}</IonCardTitle>
              </IonItem>
            </IonCardHeader>
            
            <IonCardContent>
              <IonItem lines="none">
                <IonLabel>{t("Most likely some of our services is currently not working.")}</IonLabel>
              </IonItem>
            </IonCardContent>
          </IonCard>
        );
      }
};

export default ErrorCode;
